// @ts-nocheck
import styled from "styled-components";
import {
  scarpaGray600,
  scarpaGray800,
  spanishViridian500,
  spanishViridian25,
} from "@habitech/shared";
import { GridContainer } from "src/components/common/grids";

export const Title = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: ${scarpaGray800};
`;

export const SearchWrapper = styled(GridContainer)`
  padding: 32px 0;
  align-items: end;
`;

export const Description = styled.p`
  font-size: 14px;
  color: ${scarpaGray600};
`;

export const LoadingWrapper = styled.div`
    margin: 10px auto;
`;

export const WrapperForm = styled.div`
  label {
    margin-bottom: 5px;
    display: block;
  }
  .error {
    color: red;
  }
  .date-fields {
    label {
      display: block;
    }
    > div {
      width: 100%;
    }
  }
  .state-list > div {
    width: 100%;
    .extra-large {
      width: 100%;
      height: 47px;
      &.ansky {
        top: 50px;
      }
    }
    button {
      width: 100%;
      height: 47px;
    }
  }
  .MuiInputBase-root {
    height: 47px;
    height: 47px;
    padding: 4px 10px 6px !important;
    svg {
      top: 2px;
      position: relative;
    }
  }
  .MuiInputBase-root:hover {
    background-color: ${spanishViridian25};
    cursor: pointer;
  }
  .MuiInputBase-root fieldset {
    border: 1px solid ${spanishViridian500} !important;
    border-radius: 6px;
  }
  .MuiInputBase-root fieldset:hover {
    border: none;
  }
  .Mui-focused fieldset {
    border: 2px solid ${spanishViridian500} !important;
    &.pcom-autocomplete {
      border: 2px solid ${spanishViridian500} !important;
      border-radius: 6px;
    }
  }
  .emptyPlaceHolder {
    opacity: 0.7;
  }
  .field-currency > div > div:focus-within,
  .field-leads > div > div:focus-within {
    border: 2px solid ${spanishViridian500};
    box-shadow: none;
  }
  .field-currency .currency {
    margin-bottom: 0px;
  }
  .field-leads:hover,
  .field-currency:hover {
    background-color: ${spanishViridian25};
  }
  .autocomplete .MuiInputBase-root {
    height: auto;
  }
  .MuiOutlinedInput-input {
    padding: 19.5px 4px;
  }
  .action-button {
    align-content: end;
    > div {
      margin-bottom: 0px;
    }
    button {
      float: right;
      border-radius: 6px;
      font-size: 15px;
    }
  }
  .selector button.pcom.segmented {
    padding: 10px 10px;
  }
  .selector {
    button {
      height: 47px;
    }
    div.extra-large div.extra-large {
      top: 50px;
    }
  }
  .error {
    font-size: 12px;
  }
  .MuiAutocomplete-listbox::-webkit-scrollbar {
    width: 8px;
  }
  .MuiAutocomplete-listbox::-webkit-scrollbar-thumb {
    border-radius: 20px;
    border: 2px solid #ffffff;
    background-color: #779b90;
  }
  .MuiAutocomplete-listbox li:hover,
  .MuiAutocomplete-listbox li[aria-selected="true"] {
    border-left: 2px solid #008059;
    color: #2fa377;
  }
  .MuiInputBase-input {
    cursor: pointer;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  margin-bottom: 20px;
`;
export const CloseList = styled.div`
  width: 100%;
  height: 200vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
`;
export const WrapperEndAdornment = styled.div`
  display: inline-flex;
  .pcom-loading svg {
    top: -6px;
  }
`;

export const Divider = styled.hr`
  margin: 20px 0;
`;

export const TextModal = styled.div`
  font-size: 22px;
  text-align: center;
  margin: 48px 24px 30px 24px;
`;

export const WrapperButton = styled.div`
  max-width: 250px;
  margin: auto;
  button {
    margin: auto;
  }
`;
